// extracted by mini-css-extract-plugin
module.exports = {"image":"LogoSlider_image__qC59_"};